import {Component} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {Covid19ReopeningService} from "OpsCenter/ops-support/covid-19/reopening/covid-19-reopening.service";
import {Covid19Reopening} from "OpsCenter/ops-support/covid-19/reopening/covid-19-reopening";
import * as moment from "moment";
import {OC_API} from "OpsCenter/app.constants";

@Component({
  selector: 'app-covid-19-reopening',
  template: require('./covid-19-reopening.component.html'),
  styles: [require('./covid-19-reopening.component.less')],
})
export class Covid19ReopeningComponent {
  public startDate = '';
  public merchantIds = '';

  constructor(private reopeningService: Covid19ReopeningService, private notificationService: ToastrService) {
  }

  public save(): void {
    this.reopeningService
      .save(this.convertToRequestBody())
      .subscribe(
        () => this.notificationService.success('You will be notified via email of the progress of the operation'),
        () => this.notificationService.error('Please try again')
      );
  }

  private convertToRequestBody(stringIds: string = ''): Covid19Reopening {
    const startDate = moment(this.startDate, 'DD.MM.YYYY').format(OC_API.JUST_DATE_FORMAT);
    if (this.merchantIds.length === 0) {
      return {merchantIds: [], start: startDate}
    }
    return {merchantIds: this.merchantIds.split(',').map(s => s.trim()).map(s => parseInt(s, 10)), start: startDate};
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/reopening/covid-19-reopening.component.ts